import React from 'react';
import { ResponsiveLine, ResponsiveLineCanvas } from '@nivo/line';
import { generateGradientsAndColors, generateGradients, applyGradients } from "./utils";

// This could be adjusted or enhanced based on your actual formatting needs

const nivoLineTheme = {
    axis: {
        ticks: {
            text: {
                fontSize: 12,
                fontWeight: '600',
                fontFamily: "Adobe Clean, sans-serif",
            }
        }
    },
    grid: {
        line: {
            stroke: "#ddd",
            strokeWidth: 1
        }
    },
    legends: {
        text: {
            fontSize: 12
        }
    }
}

const NivoLineChart = ({
                          data,
                          keys, // Assuming 'keys' will map to 'id' in data objects for line coloring and legends
                          customColors,
                          bottomAxisLabel = '',
                          leftAxisLabel = '',
                          precision = 1,
                          postfix = '%',
                          useMarkers = false,
                          rotateLabels = 45,
                          xInterval=5,
                          thickness=1
}) => {
    const { gradients, colorMapping } = generateGradientsAndColors(keys, customColors);
    const maxDataObject = data.reduce((acc, curr) => curr.data.length > acc.data.length ? curr : acc, data[0]);
    const tickValues = maxDataObject.data
      .filter((_, index) => index % 5 === 0)
      .map(item => item.x);

    return (
        <ResponsiveLineCanvas
            data={data}
            theme={nivoLineTheme}
            margin={{ top: 50, right: 30, bottom: 20, left: 30 }}
            xScale={{ type: 'point' }}
            yScale={{ type: 'linear', stacked: false, min: 'auto', max: 'auto' }}
            curve="natural"
            axisTop={null}
            axisRight={null}
            useMesh={true}
            enableGridX={false}
            enablePoints={useMarkers}
            axisBottom={{
                orient: 'bottom',
                tickSize: 5,
                tickPadding: 5,
                legend: bottomAxisLabel,
                legendOffset: 6,
                legendPosition: 'middle',
                tickRotation: rotateLabels,
                tickValues: tickValues
            }}

            axisLeft={{
                orient: 'left',
                tickSize: 5,
                tickPadding: 5,
                tickRotation: 0,
                legend: leftAxisLabel,
                legendOffset: -40,
                legendPosition: 'middle'
            }}
            colors={d => colorMapping[d.id]}
            pointSize={10}
            pointColor={{ theme: 'background' }}
            pointBorderWidth={2}
            pointBorderColor={{ from: 'serieColor' }}
            pointLabel="y"
            pointLabelYOffset={-12}
            lineWidth={thickness}
            legends={[
                {
                    anchor: 'top-right',
                    direction: 'column',
                    justify: false,
                    translateX: 100,
                    translateY: 0,
                    itemsSpacing: 0,
                    itemDirection: 'left-to-right',
                    itemHeight: 20,
                    itemOpacity: 0.75,
                    symbolSize: 12,
                    itemWidth: 250,
                    symbolShape: 'circle',
                    effects: [
                        {
                            on: 'hover',
                            style: {
                                itemBackground: 'rgba(0, 0, 0, .03)',
                                itemOpacity: 1
                            }
                        }
                    ]
                }
            ]}
            defs={generateGradients(keys, customColors)}
            fill={applyGradients(keys)}
            animate={true}
            motionStiffness={90}
            motionDamping={15}
        />
    );
};

export default NivoLineChart;
